import { render, staticRenderFns } from "./homeDashboardUserStatistics.vue?vue&type=template&id=06d74a9c&scoped=true"
import script from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardUserStatistics.vue?vue&type=style&index=0&id=06d74a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d74a9c",
  null
  
)

export default component.exports